import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import { fetchNotificationById } from '../../store/actions';
import { clearCurrentNotification } from '../../store/notifications';
import { selectCurrentNotification, selectNotificationsError, selectNotificationsLoading } from '../../store/selectors';

export const useNotification = (id: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const notification = useSelector(selectCurrentNotification);
  const loading = useSelector(selectNotificationsLoading);
  const error = useSelector(selectNotificationsError);

  useEffect(() => {
    if (id) {
      dispatch(fetchNotificationById(id));
    }
    return () => {
      dispatch(clearCurrentNotification());
    };
  }, [dispatch, id]);

  return { notification, loading, error };
};
